import {
  FEATURE_FLAG_META_BY_KEY,
  KNOWN_FEATURE_FLAG_KEYS,
  STAFF_OVERRIDE_FLAGS,
  type FeatureFlagMap,
} from "encamp-shared/src/featureFlags";
import { useMemo } from "react";

import { useCurrentUser } from "./useCurrentUser";
import { useTenant } from "./useTenant";

export function useFeatureFlags(): {
  featureFlags: FeatureFlagMap;
  loading: boolean;
} {
  const { tenant, loading: tenantLoading } = useTenant();
  const { isStaff, loading: userLoading } = useCurrentUser();

  const featureFlags = useMemo(() => {
    const valueByKey = new Map(
      (tenant?.tenantConfigs ?? []).map((config) => [config.key, config.value])
    );

    const flagMap = Object.fromEntries(
      KNOWN_FEATURE_FLAG_KEYS.map((key) => [
        key,
        valueByKey.get(key) ?? FEATURE_FLAG_META_BY_KEY[key].defaultValue,
      ])
    ) as FeatureFlagMap;

    if (isStaff) {
      for (const flag of STAFF_OVERRIDE_FLAGS) {
        flagMap[flag] = true;
      }
    }

    return flagMap;
  }, [tenant?.tenantConfigs, isStaff]);

  return { featureFlags, loading: tenantLoading || userLoading };
}
